<template>
    <div class="table-search-components">
        <!-- <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="h5 page-card-title">{{ elCardFormTitle }}</span>
            </div>
            <div class="el-card-body"> -->
        <el-form
            :model="elCardFormObj"
            :ref="elCardFormRef"
            :inline="true"
            label-position="left"
        >
            <!-- <el-row :gutter="20"> -->
            <template v-for="(formItem, formItemIndex) in elCardFormItem">
                <!-- <el-col :span="formItem.elCol" :key="`formItem-${formItemIndex}`"> -->
                <el-form-item
                    :label="formItem.label"
                    :prop="formItem.type !== 'range' ? formItem.prop : ''"
                    :key="`formItem-${formItemIndex}`"
                >
                    <!-- { type: 'input', label: '流程分类', prop: 'category', inputSlot: 'prepend / append', inputSlotText: '', elCol: 6 } -->
                    <template v-if="formItem.type === 'input'">
                        <el-input
                            v-model="elCardFormObj[formItem.prop]"
                            :placeholder="`请输入${formItem.label}`"
                            :clearable="true"
                        >
                            <template v-if="formItem.inputSlot">
                                <template :slot="formItem.inputSlot">{{
                                    formItem.inputSlotText
                                }}</template>
                            </template>
                        </el-input>
                    </template>
                    <!-- { type: 'input', label: '流程分类', prop: 'category', inputRows: 5, elCol: 6 } -->
                    <template v-if="formItem.type === 'textarea'">
                        <el-input
                            type="textarea"
                            v-model="elCardFormObj[formItem.prop]"
                            :rows="formItem.inputRows ? formItem.inputRows : 2"
                            :placeholder="`请输入${formItem.label}`"
                            :clearable="true"
                        ></el-input>
                    </template>
                    <!-- { type: 'select', label: '状态', selectOptions: [ { value:'0', label:'未提交' }, { value:'1', label:'审批中' }, { value:'2', label:'完成' }, { value:'3', label:'驳回' } ], prop: 'state', multiples: false / true, elCol: 6 } -->
                    <template v-if="formItem.type === 'select'">
                        <el-select
                            v-model="elCardFormObj[formItem.prop]"
                            :placeholder="`请选择${formItem.label}`"
                            :clearable="true"
                            :multiple="
                                formItem.multiples &&
                                formItem.multiples === false
                                    ? false
                                    : formItem.multiples
                            "
                        >
                            <el-option
                                v-for="(
                                    optionsItem, optionsItemIndex
                                ) in formItem.selectOptions"
                                :key="optionsItemIndex"
                                :label="optionsItem.label"
                                :value="optionsItem.value"
                            ></el-option>
                        </el-select>
                    </template>
                    <template v-if="formItem.type === 'date'">
                        <el-date-picker
                            v-model="elCardFormObj[formItem.prop]"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :placeholder="`请选择${formItem.label}`"
                        ></el-date-picker>
                    </template>
                    <template v-if="formItem.type === 'daterange'">
                        <el-date-picker
                            :style="{ 'width': '270px' }"
                            v-model="elCardFormObj[formItem.prop]"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            :start-placeholder="
                                formItem.startPlaceholder
                                    ? formItem.startPlaceholder
                                    : '开始日期'
                            "
                            :end-placeholder="
                                formItem.endPlaceholder
                                    ? formItem.endPlaceholder
                                    : '结束日期'
                            "
                        ></el-date-picker>
                    </template>
                    <!-- { type: 'range', label: '利率范围', interval: [ { prop: 'startRate', placeHolder: '利率起始值' }, { prop: 'endRate', placeHolder: '利率结束值' } ], elCol: 8 } -->
                    <template v-if="formItem.type === 'range'">
                        <el-row :gutter="10">
                            <el-col :span="11">
                                <el-form-item
                                    :prop="formItem.interval[0].prop"
                                    :style="{ marginBottom: '0' }"
                                >
                                    <el-input
                                        v-model="
                                            elCardFormObj[
                                                formItem.interval[0].prop
                                            ]
                                        "
                                        :placeholder="`请输入${formItem.interval[0].placeHolder}`"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" style="text-align: center"
                                >-</el-col
                            >
                            <el-col :span="11">
                                <el-form-item
                                    :prop="formItem.interval[1].prop"
                                    :style="{ marginBottom: '0' }"
                                >
                                    <el-input
                                        v-model="
                                            elCardFormObj[
                                                formItem.interval[1].prop
                                            ]
                                        "
                                        :placeholder="`请输入${formItem.interval[1].placeHolder}`"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-if="formItem.type === 'autocomplete'">
                        <!-- v-loadMore="orgListMore"  增加懒加载的时候使用 -->
                        <el-select
                            class="selectPhaseBox"
                            v-model="elCardFormObj[formItem.prop]"
                            :multiple="false"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                            @change="orgChang"
                            @visible-change="orgVisibleChang"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                            <!-- <span v-if="orgListEnd" class="tips">无更多数据</span> -->
                        </el-select>
                    </template>
                    <template v-if="formItem.type === 'cascader'">
                        <el-cascader
                            :options="regionTreeList"
                            :props="props"
                            :placeholder="`请选择${formItem.label}`"
                            ref="refHandle"
                            v-model="elCardFormObj[formItem.prop]"
                            @change=" (val) => handleChange(val,formItem.prop)"
                            clearable
                            class="width100 el-cascader-reset"
                        ></el-cascader>
                    </template>
                </el-form-item>
                <!-- </el-col> -->
            </template>
            <!-- <el-col :span="elCardFormSearchBtn.elCol"> -->
            <el-form-item>
                <template
                    v-for="(
                        btnItem, btnItemIndex
                    ) in elCardFormSearchBtn.btnItems"
                >
                    <el-button
                        :type="btnItem.btnType"
                        :plain="btnItem.btnPlain"
                        :icon="btnItem.btnIcon"
                        :key="`btn-item-${btnItemIndex}`"
                        v-on:click="btnItem.btnClick"
                        >{{ btnItem.btnText }}
                    </el-button>
                </template>
            </el-form-item>
            <!-- </el-col> -->
            <!-- </el-row> -->
        </el-form>
        <!-- </div>
        </el-card> -->
    </div>
</template>

<script>
// import { orgsListALL } from "@/api/backOrgsManager/interfaceAPI";
// import { getFirstLevelOrg } from "@/api/rolesManager/interfaceAPI";
// import { PLATFORM_TYPE } from "@/utils/commonDic";
import { isParamEmpty } from "@/filters/index";
export default {
    name: "TableSearchComponents",
    props: {
        elCardFormTitle: {
            type: String,
            default: () => {
                return "";
            },
        },
        elCardFormObj: {
            type: Object,
            default: () => {
                return {};
            },
        },
        elCardFormRef: {
            type: String,
            default: () => {
                return "";
            },
        },
        elCardFormItem: {
            type: Array,
            default: () => {
                return [];
            },
        },
        elCardFormSearchBtn: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            loading: false,
            options: [],
            pageIndex: 1,
            pageSize: 10,
            show: false,
            orgName: "",
            orgListEnd: false,
            regionTreeList: [],
            props: {
                checkStrictly: true,
            }
        };
    },
    created() {
        // getFirstLevelOrg({
        //     name: "",
        //     orgType: PLATFORM_TYPE["FINANCIAL"],
        //     parentId: "0",
        // }).then((res) => {
        //     this.options = res.data.map((e) => {
        //         return (e = { ...e, value: e.id, label: e.name });
        //     });
        // });
    },
    watch: {
        regionTreeList: {
            handler: function (n, o) {
                if (isParamEmpty(o)) {
                    this.regionTreeList = JSON.parse(
                        window.sessionStorage.getItem("$BOROUGHSZONING")
                    );
                } else {
                    this.regionTreeList = n;
                    this.$forceUpdate();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        setInterval(function () {
            document
                .querySelectorAll(".el-cascader-node__label")
                .forEach((el) => {
                    el.onclick = function () {
                        if (this.previousElementSibling)
                            this.previousElementSibling.click();
                    };
                });
        }, 500);
    },
    methods: {
        async remoteMethod(queryString) {
            if (queryString) {
                this.orgName = queryString;
                let param = {
                    orgType: PLATFORM_TYPE["FINANCIAL"],
                    parentId: "0",
                    name: this.orgName,
                };
                let orgList = await this.orgListAcquire(param);
                this.options = orgList.data.map((e) => {
                    return (e = { ...e, value: e.id, label: e.name });
                });
                if (this.options.length < this.pageSize) {
                    this.orgListEnd = true;
                    this.show = true;
                }
            }
        },
        orgListAcquire(param) {
            return new Promise((resolve, reject) => {
                this.loading = true;
                getFirstLevelOrg(param)
                    .then((res) => {
                        this.loading = false;
                        resolve(res);
                    })
                    .catch((err) => {
                        this.loading = false;
                        reject(err);
                    });
            });
        },
        async orgListMore() {
            // alert('1')
            if (this.show) return;
            this.pageIndex = ++this.pageIndex;
            this.show = true;
            let param = {
                orgType: PLATFORM_TYPE["FINANCIAL"],
                parentId: "0",
                name: this.orgName,
            };
            let orgList = await this.orgListAcquire(param);
            let dataList = orgList.data.map((e) => {
                return (e = { ...e, value: e.id, label: e.name });
            });
            this.options = [...this.options, ...dataList];
            if (dataList.length < this.pageSize) {
                this.orgListEnd = true;
                this.show = true;
            } else {
                this.show = false;
            }
        },
        orgChang() {
            this.initialize();
        },
        async initialize() {
            this.show = false;
            this.pageIndex = 1;
            this.options = [];
            this.orgListEnd = false;
            this.orgName = "";
            let param = {
                orgType: PLATFORM_TYPE["FINANCIAL"],
                parentId: "0",
                name: this.orgName,
            };
            let orgList = await this.orgListAcquire(param);
            this.options = orgList.data.map((e) => {
                return (e = { ...e, value: e.id, label: e.name });
            });
        },
        orgVisibleChang(visible) {
            if (!visible) {
                this.initialize();
            }
        },
        handleChange(options, prop) {
            this.elCardFormObj[prop] = options[options.length - 1]
            this.$refs.refHandle[0].dropDownVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.tips {
    text-align: center;
    display: inherit;
    line-height: 30px;
    color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/TableSearch/tableSearch.vue